
import { Pipe, PipeTransform } from '@angular/core';
import {User} from './user-management.model';

@Pipe({
  name: 'searchPipe',
  pure: false
})
export class SearchPipe implements PipeTransform {
  transform(data: User[], searchTerm: string): any[] {
    if (searchTerm) {
      searchTerm = searchTerm.toUpperCase();
      return data.filter(item => {
        return item.firstName.toUpperCase().indexOf(searchTerm) !== -1 || item.lastName.toUpperCase().indexOf(searchTerm) !== -1 ||
          item.email.toUpperCase().indexOf(searchTerm) !== -1;
      });
    } else {
      return data;
    }

  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/search-users.pipe.ts